import React from "react";
import { Dropdown, Menu, Switch } from "antd";

import styles from "./style.module.scss";
import getRighNavtSVG from "../../utils/RightnavSvg";

export const CustomTable = ({
	columns,
	data,
	tableId,
	onDragStart,
	onDrop,
	onReorder,
	showHeader = true,
	onVisibilityChange,
	onEdit,
	onDelete,
	isProfile
}) => {
	const gridTemplate = columns.map((c) => c.width).join(" ");
	const filteredData = data.filter((row) => {
		if (!isProfile && row.tabType === "PROFILE") {
			return false;
		}
		return true;
	});

	return (
		<div
			className={styles.table}
			style={{ gridTemplateColumns: gridTemplate }}
			onDragOver={(e) => e.preventDefault()}
			onDrop={() => onDrop(tableId)}>
			{showHeader &&
				columns.map((col) => (
					<div
						key={col.key}
						className={styles.headerCell}
						data-col={col.key}>
						<div className={styles.cellContent}>{col.label}</div>
					</div>
				))}

			{filteredData.length === 0 && (
				<div
					className={styles.emptyRow}
					style={{ gridColumn: `1 / -1` }}>
					No records to display
				</div>
			)}

			{filteredData.map((row, index) => (
				<React.Fragment key={`${tableId}-${index}`}>
					{columns.map((col) => (
						<div
							key={col.key}
							className={styles.cell}
							data-col={col.key}
							draggable={col.key === "move"}
							onDragStart={() => onDragStart(tableId, index)}
							onDrop={() => onReorder(tableId, index)}>
							<div
								className={styles.cellContent}
								// Only the move column needs cursor styling
								style={
									col.key === "move"
										? { cursor: "grab", justifyContent: "center" }
										: {}
								}>
								{renderCell(col.key, row, onVisibilityChange, onEdit, onDelete, isProfile)}
							</div>
						</div>
					))}
				</React.Fragment>
			))}
		</div>
	);
};

const renderCell = (key, row, onVisibilityChange, onEdit, onDelete, isProfile) => {
	const legacyCoreIds = [
		"FILTERS",
		"NOTIFICATIONS",
		"LANGUAGE",
		"FULL_SCREEN",
		"KNOWLEDGE_BASE",
		"HELP_DESK",
		"FEATURE_REQUESTS",
		"CHAT",
		"LIA",
	];
	switch (key) {
		case "move":
			return <span className="drag-handle">≡</span>;
		case "icon":
			return row.iconType == "IMAGE" ? (
				<img src={row.icon} width={24} />
			) : row.iconType == "CUSTOM_SVG" ? (
				<span className={styles.customSvgIcon} dangerouslySetInnerHTML={{ __html: row.icon }} />
			) : (
				<NavIcon icon={row.icon} />
			);
		case "link":
			return row.link ? <a href={row.link}>{row.link}</a> : null;
		case "type":
			return getType[row.type];
		case "action":
			if (isProfile && row.tabType && (row.tabType.toUpperCase() === "CORE" || row.tabType.toUpperCase() === "DOMAIN")) {
				return null;
			}
			const menu = (
				<Menu>
					<Menu.Item
						key="edit"
						onClick={() => onEdit(row)}>
						Edit
					</Menu.Item>
					{!legacyCoreIds.includes(row.coreId) && (!row.tabType || row.tabType.toUpperCase() !== "CORE") && <Menu.Item
						key="delete"
						onClick={() => onDelete(row)}>
						Delete
					</Menu.Item>}
				</Menu>
			);

			return (
				<Dropdown
					overlay={menu}
					trigger={["click"]}>
					{/* This is the 3-vertical-dots icon button */}
					<span
						style={{
							cursor: "pointer",
							fontSize: 18,
							display: "inline-block",
							padding: "0 4px",
						}}>
						⋮
					</span>
				</Dropdown>
			);
		case "tabType":
			return row.tabType ? row.tabType.charAt(0).toUpperCase() + row.tabType.slice(1).toLowerCase() : "";
		case "visibility":
			return (
				<Switch
					checked={row.visibility} // assuming your row object has a 'visible' boolean
					onChange={(checked) => onVisibilityChange(row, checked)}
				/>
			);
		default:
			return row[key];
	}
};

const getType = {
	RIGHT_NAV: "Right Nav",
	CONTROL: "Control",
	EXTERNAL: "External",
	INTERNAL: "Main Content",
};

const NavIcon = ({ icon, iconType }) => {
	if (!icon) return null;

	if (iconType === "CUSTOM_SVG") {
		return <span className={styles.customSvgIcon} dangerouslySetInnerHTML={{ __html: icon }} />;
	}

	return (
		<span className={styles.icons}>{getRighNavtSVG(icon)}</span>
	);
};
